<script>
  import { onMount } from "svelte";
  import { goto } from "@/utils/navigationUtils";
  import WikiHeader from "@/components/sections/Wiki/header.svelte";
  import WikiFooter from "@/components/sections/Wiki/footer.svelte";
  import Profile from "@/components/sections/Profile.svelte";
  import constants from "@/constants";
  import ShortVideoAppHead from "@/components/molecules/ShortVideoApp/head.svelte";
  import GridWrapper from "@/components/organisms/GridWrapper.svelte";
  import { isMobile, _sanitizeInput } from "@/utils/helpers/utils";
  import { _normalizeNumber } from "@/utils";
  import InstallBanner from "@/components/molecules/InstallBanner.svelte";
  import config from "@/config";
  import ProfileItemHead from "@/components/molecules/ProfileItemHead.svelte";
  import { getProfileByHandle, getProfileVideosByUserId } from "@/api";
  import userProfileStore from "@/stores/userProfiles";

  const { NOT_FOUND_URL, NO_MORE_POSTS_OFFSET } = constants;

  const { downloadAppUrl } = config;
  export let data;

  export let { handle } = data;
  export let item = $userProfileStore.list[handle];
  export let videos = item && item.videos ? item.videos : [];
  export let lp = item ? item.lp : undefined;

  let meta_title, meta_desc, og_tags;
  $: if (item) {
    const likes_count = item.likeCount || 0;
    meta_title = `${item.n} on Moj`;
    meta_desc = `@${item.h} - ${_normalizeNumber(
      likes_count
    )} Likes - Watch awesome short videos created by ${item.n}`;

    const iosDeepLinkUrl = `mojapp://profile/${handle}`;
    og_tags = [
      { p: "og:title", c: meta_title },
      { p: "og:description", c: meta_desc },
      { p: "og:image", c: item.pu },
      { p: "al:ios:url", c: iosDeepLinkUrl },
    ];
  }

  $: hasData = typeof item === "object" && item;
  let hasMoreVideosData = true;
  let fetchingVideosData = false;
  let showBanner = false;
  /**
   * fetches user profile videos
   *
   */

  const fetchVideosData = async (reducerAction = "concat") => {
    if (fetchingVideosData || lp === NO_MORE_POSTS_OFFSET) return;
    fetchingVideosData = true;

    try {
      const { d, lp: newLp } = await getProfileVideosByUserId(
        window.fetch,
        item.i,
        lp
      );
      if (newLp !== lp) {
        videos = [...videos, ...d];
        lp = newLp;
        userProfileStore.updateVideos(handle, d, newLp, reducerAction);
      }
      if (!d || d.length <= 0) {
        hasMoreVideosData = false;
      }
    } catch (e) {
      console.warn(e);
    } finally {
      fetchingVideosData = false;
    }
  };

  onMount(async () => {
    showBanner = isMobile();

    if (!hasData) {
      try {
        item = await getProfileByHandle(window.fetch, handle);
      } catch (e) {
        console.warn(e);
      }
    }

    if (item && item.err) {
      await goto(NOT_FOUND_URL);
    }

    if (item) {
      userProfileStore.updateState(handle, item);

      if (videos && videos.length > 0) {
        userProfileStore.updateVideos(handle, videos, lp, "replace");
      } else {
        await fetchVideosData("replace");
      }
    }
  });
</script>

<div class="bg-black text-white">
  <ShortVideoAppHead
    ogTagsFromParams={og_tags}
    titleFromParams={meta_title}
    descFromParams={meta_desc}
  />
  {#if item}
    <ProfileItemHead {item} />
  {/if}
  <WikiHeader
    theme="dark"
    homeRoute="/"
    source="profile"
    headerLinks={[
      { r: "/wiki", n: "Moj Stars" },
      {
        nt: 1,
        r: downloadAppUrl,
        n: "Download App",
      },
    ]}
  />

  {#if item}
    <main class="bg-black text-white pt-10">
      <Profile {item} {handle} />
      <GridWrapper
        linkPrefix={`/@${handle}/feed`}
        {videos}
        {hasMoreVideosData}
        {fetchingVideosData}
        {fetchVideosData}
      />
      <InstallBanner intentUrl={`/@${handle}`} source="profile" />
    </main>
  {/if}

  <WikiFooter theme="dark" {showBanner} />
</div>
